import { useEffect, useState } from "react";
import { toast } from "sonner";

const STATUSES = ["pending", "approved", "rejected", "completed", "cancelled"];

export default function AdminBookings({ api, t }) {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => {
    api.get("/admin/bookings", { params: filter ? { status: filter } : {} }).then((r) => setItems(r.data));
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [filter]);

  const force = async (b, s) => {
    await api.patch(`/admin/bookings/${b.id}/force-status`, { status: s });
    setItems((arr) => arr.map((x) => x.id === b.id ? { ...x, status: s } : x));
    toast.success(t("admin.actionOk"));
  };

  return (
    <div>
      <div className="flex gap-2 mb-4 flex-wrap">
        <select className="input-tech w-auto" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="admin-bookings-filter">
          <option value="">— {t("market.any")} —</option>
          {STATUSES.map((s) => <option key={s} value={s}>{t(`status.${s}`)}</option>)}
        </select>
      </div>
      <div className="divide-y divide-[var(--ink-200)]">
        {items.map((b) => (
          <div key={b.id} className="py-3 flex items-center gap-3 flex-wrap" data-testid={`admin-booking-${b.id}`}>
            <div className="flex-1 min-w-[240px]">
              <div className="font-display">{b.listing_title}</div>
              <div className="label-tech mt-1">{b.buyer_name} → {b.seller_id.slice(0,10)} · {b.quantity} · {b.method} · <span className="text-[var(--brick)]">{t(`status.${b.status}`)}</span></div>
            </div>
            <select className="input-tech w-auto text-xs" defaultValue="" onChange={(e) => e.target.value && force(b, e.target.value)} data-testid={`admin-force-${b.id}`}>
              <option value="">{t("admin.forceStatus")}</option>
              {STATUSES.map((s) => <option key={s} value={s}>{t(`status.${s}`)}</option>)}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
